export default function updateAction(state, payload) {
  return {
    ...state,
    gradevinski: {
      ...state.gradevinski,
      ...payload,
    },
  };
}
